var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"tw-mx-auto tw-h-96 tw-my-5",attrs:{"src":require("../assets/icons/credit-analysis-coming-soon.svg")}})])
}]

export { render, staticRenderFns }